// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAutoInvestmentRuleDto } from './IAutoInvestmentRuleDto';
import {
    IAutoInvestmentRuleDtoFromJSON,
    IAutoInvestmentRuleDtoFromJSONTyped,
    IAutoInvestmentRuleDtoToJSON,
    IAutoInvestmentRuleDtoToJSONTyped,
} from './IAutoInvestmentRuleDto';

/**
 * 
 * @export
 * @interface IAutoInvestmentSchedulerRequestDto
 */
export interface IAutoInvestmentSchedulerRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentSchedulerRequestDto
     */
    investor_account_id: number;
    /**
     * 
     * @type {number}
     * @memberof IAutoInvestmentSchedulerRequestDto
     */
    amount_to_keep: number;
    /**
     * 
     * @type {Array<IAutoInvestmentRuleDto>}
     * @memberof IAutoInvestmentSchedulerRequestDto
     */
    auto_investment_rules?: Array<IAutoInvestmentRuleDto>;
}

/**
 * Check if a given object implements the IAutoInvestmentSchedulerRequestDto interface.
 */
export function instanceOfIAutoInvestmentSchedulerRequestDto(value: object): value is IAutoInvestmentSchedulerRequestDto {
    if (!('investor_account_id' in value) || value['investor_account_id'] === undefined) return false;
    if (!('amount_to_keep' in value) || value['amount_to_keep'] === undefined) return false;
    return true;
}

export function IAutoInvestmentSchedulerRequestDtoFromJSON(json: any): IAutoInvestmentSchedulerRequestDto {
    return IAutoInvestmentSchedulerRequestDtoFromJSONTyped(json, false);
}

export function IAutoInvestmentSchedulerRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAutoInvestmentSchedulerRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'investor_account_id': json['investor_account_id'],
        'amount_to_keep': json['amount_to_keep'],
        'auto_investment_rules': json['auto_investment_rules'] == null ? undefined : ((json['auto_investment_rules'] as Array<any>).map(IAutoInvestmentRuleDtoFromJSON)),
    };
}

export function IAutoInvestmentSchedulerRequestDtoToJSON(json: any): IAutoInvestmentSchedulerRequestDto {
    return IAutoInvestmentSchedulerRequestDtoToJSONTyped(json, false);
}

export function IAutoInvestmentSchedulerRequestDtoToJSONTyped(value?: IAutoInvestmentSchedulerRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investor_account_id': value['investor_account_id'],
        'amount_to_keep': value['amount_to_keep'],
        'auto_investment_rules': value['auto_investment_rules'] == null ? undefined : ((value['auto_investment_rules'] as Array<any>).map(IAutoInvestmentRuleDtoToJSON)),
    };
}

